import { RectangleButton } from "../Actions";
import Content from "./Content";
import CB from "../../assets/Coinbase.svg";
import MM from "../../assets/MetaMask.svg";

const CreateWallet: React.FC<{
  onClickMeta: () => void;
  onClickCb: () => void;
}> = ({ onClickCb, onClickMeta }) => {
  return (
    <>
      <Content
        title={"We can help you create a wallet on Coinbase or MetaMask."}
        description={"Which would you like to use?"}
        tooltipContent={{
          title: "Wallet Tip",
          description:
            "A Coinbase wallet is different from a Coinbase account. If you're not sure, you probably don’t have a wallet."
        }}>
        <div className="flex flex-col tab:flex-row gap-4 w-full mt-6">
          <RectangleButton
            analyticsProperty="yes on coinbase"
            color="teal"
            onClick={onClickCb}>
            <CB width="48" className="mb-2" />
            Coinbase
            <span className="body2 text-coinage-body">
              Go with Coinbase if you already have an account and want to keep
              things consolidated.
            </span>
          </RectangleButton>
          <RectangleButton
            color="teal"
            analyticsProperty="yes on metamask"
            onClick={onClickMeta}>
            <MM width="48" className="mb-2" />
            Metamask
            <span className="body2 text-coinage-body">
              Go with MetaMask if you want a wallet that everyone knows and many
              people use.
            </span>
          </RectangleButton>
        </div>
      </Content>
    </>
  );
};

export default CreateWallet;
